module.exports = __webpack_public_path__ + "img/slider-2.4bcf8f19.jpg";